import { fmtMoney } from "@/lib/format";
import { Package as PackageIcon } from "@phosphor-icons/react";

export default function PackageUptakeWidget({ items = [] }) {
  return (
    <div className="bg-canvas-card border border-canvas-line">
      <div className="px-5 py-4 border-b border-canvas-line flex items-center justify-between">
        <div>
          <div className="font-mono text-[10px] tracking-[0.3em] uppercase text-ink-muted mb-1">
            06 / Bundles
          </div>
          <h3 className="font-display text-lg font-semibold text-ink">Most attached packages</h3>
        </div>
        <PackageIcon size={18} weight="bold" className="text-ink" />
      </div>
      <ul className="divide-y divide-canvas-line">
        {items.length === 0 && (
          <li className="px-5 py-8 font-mono text-xs text-ink-subtle text-center">
            No packages attached to any sales yet.
          </li>
        )}
        {items.map((pkg) => (
          <li
            key={pkg.id}
            data-testid={`top-pkg-${pkg.id}`}
            className="px-5 py-3"
          >
            <div className="flex items-center justify-between gap-3 mb-1.5">
              <span className="text-sm font-semibold text-ink truncate">{pkg.name}</span>
              <span className="font-mono text-sm font-semibold text-ink shrink-0">
                {fmtMoney(pkg.total_revenue)}
              </span>
            </div>
            <div className="flex items-center gap-3">
              <div className="flex-1 h-1.5 bg-canvas-panel">
                <div
                  className="h-full bg-ink transition-all duration-300"
                  style={{ width: `${Math.min(100, pkg.attach_rate)}%` }}
                />
              </div>
              <span className="font-mono text-[11px] text-ink-muted shrink-0">
                {pkg.attach_count} sale{pkg.attach_count === 1 ? "" : "s"} ·{" "}
                {pkg.attach_rate.toFixed(0)}%
              </span>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
}
